import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-mystical theme-bg-background">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '1rem',
            padding: '2.5rem',
          }}
        >
          <h1 className="text-3xl font-bold text-white mb-2">Política de Privacidade</h1>
          <p className="text-white/40 text-sm mb-8">Última atualização: maio de 2025</p>

          <div className="space-y-8 text-white/80 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-white mb-3">1. Quem somos</h2>
              <p>
                O <strong className="text-white">Astralyz</strong> é uma plataforma de tarot e astrologia
                personalizada com uso de inteligência artificial. Nós respeitamos sua privacidade e estamos
                comprometidos em proteger seus dados pessoais em conformidade com a Lei Geral de Proteção
                de Dados (LGPD — Lei nº 13.709/2018).
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">2. Dados que coletamos</h2>
              <ul className="list-disc list-inside space-y-2">
                <li><strong className="text-white">Dados de conta:</strong> nome, e-mail e senha (armazenada em hash).</li>
                <li><strong className="text-white">Dados de perfil:</strong> data de nascimento, cidade de nascimento, gênero, estado civil e profissão — usados para personalizar o mapa astral e as leituras.</li>
                <li><strong className="text-white">Dados de uso:</strong> histórico de consultas de tarot e interações com a plataforma.</li>
                <li><strong className="text-white">Dados de pagamento:</strong> registros de transações (processadas pelo Mercado Pago; não armazenamos dados do cartão).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">3. Como usamos seus dados</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Gerar seu mapa astral e leituras de tarot personalizadas.</li>
                <li>Enviar comunicações relacionadas à sua conta (verificação de e-mail, redefinição de senha).</li>
                <li>Melhorar nossos serviços de forma agregada e anônima.</li>
                <li>Cumprir obrigações legais.</li>
              </ul>
              <p className="mt-3">
                Não vendemos, alugamos nem compartilhamos seus dados pessoais com terceiros para fins
                comerciais.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">4. Base legal</h2>
              <p>
                O tratamento dos seus dados é realizado com base no seu <strong className="text-white">consentimento</strong> (art. 7º, I, LGPD)
                e na execução do contrato de prestação de serviços (art. 7º, V, LGPD). Você pode retirar
                o consentimento a qualquer momento, o que implicará na exclusão da sua conta.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">5. Armazenamento e segurança</h2>
              <p>
                Seus dados são armazenados em servidores seguros. Utilizamos criptografia para proteger
                senhas e comunicações. O acesso aos dados é restrito a sistemas automatizados necessários
                para a prestação do serviço.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">6. Seus direitos</h2>
              <p>Nos termos da LGPD, você tem direito a:</p>
              <ul className="list-disc list-inside space-y-2 mt-2">
                <li>Confirmar a existência de tratamento e acessar seus dados.</li>
                <li>Corrigir dados incompletos, inexatos ou desatualizados.</li>
                <li>Solicitar a exclusão dos seus dados pessoais.</li>
                <li>Revogar o consentimento a qualquer momento.</li>
                <li>Solicitar a portabilidade dos dados.</li>
              </ul>
              <p className="mt-3">
                Para exercer esses direitos, entre em contato pelo e-mail{' '}
                <strong className="text-white">privacidade@astralyz.com.br</strong>.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">7. Cookies</h2>
              <p>
                Utilizamos apenas cookies estritamente necessários para manter sua sessão autenticada.
                Não utilizamos cookies de rastreamento ou publicidade.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">8. Alterações nesta política</h2>
              <p>
                Podemos atualizar esta política periodicamente. Em caso de alterações relevantes,
                notificaremos por e-mail ou aviso na plataforma. O uso continuado após a notificação
                implica aceitação das mudanças.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-3">9. Contato</h2>
              <p>
                Dúvidas sobre esta política podem ser enviadas para{' '}
                <strong className="text-white">privacidade@astralyz.com.br</strong>.
              </p>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-white/10 text-center">
            <Link
              to="/register"
              className="inline-block px-6 py-3 rounded-xl font-semibold text-white"
              style={{ background: 'linear-gradient(to right, #7c3aed, #8b5cf6)' }}
            >
              Voltar ao cadastro
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
